import { AssistantField } from '@kizenapps/engine';
import { ImageWrapper } from '../styles';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { getLinkValue } from '@kizenapps/engine/util';
import { getParamFromAuth } from './util';

const ImageParent = ({
  children,
  field,
}: {
  children: React.ReactNode;
  field?: AssistantField;
}) => {
  const auth = useSelector((state: any) => state.authentication);

  const linkValue = useMemo(() => {
    if (!field?.link?.href) {
      return null;
    }

    const val = getLinkValue(
      field.link.href,
      field.include,
      getParamFromAuth(auth)
    );

    return val;
  }, [auth, field?.link?.href, field?.include]);

  if (linkValue) {
    return (
      <ImageWrapper>
        <a
          href={linkValue}
          target="_blank"
          rel="noopener noreferrer"
          title={field?.link?.text}
        >
          {children}
        </a>
      </ImageWrapper>
    );
  }
  return <ImageWrapper>{children}</ImageWrapper>;
};

const isDimensionless = (field: AssistantField) => {
  return !field.width && !field.height;
};

const getWidth = (field: AssistantField) => {
  if (isDimensionless(field)) {
    return '100%';
  }

  if (field.width || field.width === 0) {
    return `${field.width}px`;
  }

  return 'auto';
};

const getHeight = (field: AssistantField) => {
  if (isDimensionless(field)) {
    return 'auto';
  }

  if (field.height || field.height === 0) {
    return `${field.height}px`;
  }

  return 'auto';
};

export const ImageBlock = ({ field }: { field: AssistantField }) => {
  const width = getWidth(field);
  const height = getHeight(field);

  return (
    <ImageParent field={field}>
      <img
        src={field.src}
        alt={field.title}
        style={{
          width: width,
          height: height,
          maxWidth: '100%',
        }}
        title={field.title}
      />
    </ImageParent>
  );
};
